import React, { lazy, Suspense } from 'react';
import { formErrorMessage } from './FormErrorMessage';
import { ErrorMessage, FastField } from 'formik';
import PropTypes from 'prop-types';
import StyledLoading from '../loading/StyledLoading';

// Lazy load HTMLTextEditor
const HTMLTextEditor = lazy(() => import('../HTMLTextEditor'));

const FormikHTMLInputField = ({
  name='',
  maxChar,
  isHideError,
  onChangeData,
  onCharacterCountExceed,
  ...props
}) => {
  return (
    <FastField name={name} {...props}>
      {({ field: { value }, form: { setFieldValue } }) => (
        <>
          <Suspense fallback={<StyledLoading />}>
            <HTMLTextEditor
              value={value ?? ''}
              name={name}
              onCharacterCountExceed={onCharacterCountExceed}
              onChange={(data) => {
                setFieldValue(name, data);
                onChangeData && onChangeData(data);
              }}
              maxCharacters={maxChar}
              {...props}
            />
          </Suspense>

          {!isHideError && (
            <div style={{ marginTop: '-30px' }}>
              <ErrorMessage name={name} render={formErrorMessage} />
            </div>
          )}
        </>
      )}
    </FastField>
  );
};

FormikHTMLInputField.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  as: PropTypes.string,
  rows: PropTypes.string,
  onCharacterCountExceed: PropTypes.func,
};

export default React.memo(FormikHTMLInputField);
